import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import useCurrency from 'hooks/useCurreny';
import MaskInput from 'components/MaskedInput';
import { useCroptimizer } from 'features/Croptimizer/providers/CroptimizerContext';

interface Props {
  om: string;
  setOm: (value: string) => void;
  n: string;
  setN: (value: string) => void;
  p: string;
  setP: (value: string) => void;
  k: string;
  setK: (value: string) => void;
  s: string;
  setS: (value: string) => void;
  disabled: boolean;
  errorOrganicMatter: string | null;
}

const CropOm: FC<Props> = ({
  om,
  setOm,
  n,
  setN,
  p,
  setP,
  k,
  setK,
  s,
  setS,
  disabled,
  errorOrganicMatter,
}) => {
  const { t } = useTranslation();
  const { currencyGreen } = useCurrency();
  const { kg } = useCroptimizer();

  return (
    <div className="flex mx-[-0.5rem] sm:flex-wrap">
      <div className='w-2/6 sm:w-full sm:max-w-full px-2'>
        <div className="font-bold text-lg mb-5">{t('organicMatter')}</div>
        <div>
          <MaskInput
            titleClassName={`${
              disabled ? 'bg-transparent' : 'bg-white'
            } top-[-9px] left-[8px]`}
            title={t('om')}
            className="w-full"
            value={om}
            onChange={setOm}
            disabled={disabled}
            redBorder={!!errorOrganicMatter}
            suffix=" %"
          />
          <div className="text-[#FF3B30] text-xs ml-1 mt-1 sm:mt-[-15px] sm:mb-4 h-2">
            {errorOrganicMatter && <div> {errorOrganicMatter}</div>}
          </div>
        </div>
      </div>
      <div className='w-4/6 sm:w-full px-2'>
        <div className="font-bold text-lg mb-5">
          {t('npkPrices')} ({currencyGreen}/{kg})
        </div>
        <div className="flex mx-[-0.5rem] sm:flex-col sm:space-x-0">
          <div className="w-1/4 sm:w-full sm:max-w-full sm:mb-8 px-2">
            <MaskInput
              titleClassName={`${
                disabled ? 'bg-transparent' : 'bg-white'
              } top-[-9px] left-[8px]`}
              title="N"
              className="w-full "
              value={n}
              onChange={setN}
              disabled={disabled}
            />
          </div>
          <div className="w-1/4 sm:w-full sm:max-w-full sm:mb-8 px-2">
            <MaskInput
              titleClassName={`${
                disabled ? 'bg-transparent' : 'bg-white'
              } top-[-9px] left-[8px]`}
              title={
                <div>
                  P<sub>2</sub>O<sub>5</sub>
                </div>
              }
              className="w-full "
              value={p}
              onChange={setP}
              disabled={disabled}
            />
          </div>
          <div className="w-1/4 sm:w-full sm:max-w-full sm:mb-8 px-2">
            <MaskInput
              titleClassName="bg-transparent top-[-9px] left-[8px]"
              title={
                <div>
                  K<sub>2</sub>O
                </div>
              }
              className="w-full"
              value={k}
              onChange={setK}
              disabled={disabled}
            />
          </div>
          <div className="w-1/4 sm:w-full sm:max-w-full px-2">
            <MaskInput
              titleClassName="bg-transparent top-[-9px] left-[8px]"
              title={
                <div>
                  SO<sub>3</sub>
                </div>
              }
              className="w-full"
              value={s}
              onChange={setS}
              disabled={disabled}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CropOm;
